<template>
		<vueSelect
			:searchable="false"
			:options="data.values"
			:placeholder="transformedLabel"
			v-model="data.currentValue"
		/>
</template>

<script>
import vueSelect from 'vue-select'

export const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default {
	props: ['data'],
	name: "DiscoveryTableSortingSingle",
	components: {
		vueSelect
	},
	computed: {
		transformedLabel() {
			return this.data.label.replace('_', " ").split(' ').map(capitalize).join(' ');
		}
	}
}
</script>

<style scoped lang="scss">

.v-select.vs--single.vs--unsearchable {
	border: 1px solid #eee;
}
</style>